var module = angular.module('octopusApp.configuration');

module.directive('subscriptionEditor', function() {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'areas/configuration/audit/subscriptions/views/editor.html'
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/audit/subscriptions/directives/subscription_editor.js
// module id = 382
// module chunks = 1